import { Corner, MDCMenuSurface } from '@material/menu-surface'

export default {
  setup() {
    this.surfaceEl = this.el.querySelector('.mdc-menu-surface')
    this.surface = new MDCMenuSurface(this.surfaceEl)

    // The default corner puts the surface over the anchor, which hides the
    // icon button that opens it. The user then cannot click that button to
    // close the surface. Corner.TOP_END puts the surface beside the button
    // instead, to the right when it fits and to the left when it does not.
    // MDCMenuSurface picks the vertical side the same way: down when the
    // room exists, up when it does not.
    this.surface.setAnchorCorner(Corner.TOP_END)

    const trigger = this.el.querySelector('[data-menu-surface-trigger]')

    // The surface registers a capturing body click listener while it is open.
    // The trigger sits outside the surface, so that listener closes the surface
    // before this click handler runs. The open state is read one event earlier.
    this.openAtPointerDown = false

    trigger.addEventListener('pointerdown', () => {
      this.openAtPointerDown = this.surface.isOpen()
    })

    trigger.addEventListener('click', () => {
      if (this.openAtPointerDown) return

      // Opening leaves focus on the icon button, which keeps the Material
      // Design focus ripple on it while the surface is open.
      this.surface.open()
    })

    // NOTE: the surface opens and closes in the browser while the server
    // receives nothing. A caller that applies each change through phx-change
    // works.
    //
    // To notify a caller when the surface closes, add a listener.
    //
    //   this.surfaceEl.addEventListener('MDCMenuSurface:closed', () => {
    //     this.pushEventTo(this.el, 'menu-surface-closed', {})
    //   })
    //
    // pushEventTo reads the owner from the DOM, so the event reaches the live
    // component or the live view that rendered the surface. menu_surface.ex
    // needs no change if the element and the event name are constants. To vary
    // the event name or the target per call site, add props to menu_surface.ex.
    //
    // MDCMenuSurface fires an opened event and a closing event too.
  },
  destroy() {
    this.surface?.destroy()
    this.surface = null
  },
  mounted() {
    this.setup()
  },
  // A LiveView patch rewrites this subtree from the server markup. That markup
  // contains neither the open class nor the position MDCMenuSurface computed.
  // An open surface would then vanish or move whenever a checkbox inside it
  // sends an event. Save both before the patch. Restore them after it.
  beforeUpdate() {
    this.wasOpen = this.surface.isOpen()
    this.savedStyle = this.surfaceEl.getAttribute('style')
  },
  updated() {
    if (!this.wasOpen) return

    this.surfaceEl.classList.add('mdc-menu-surface--open')
    if (this.savedStyle) this.surfaceEl.setAttribute('style', this.savedStyle)
  },
  destroyed() {
    this.destroy()
  }
}
